(function () {
  if (window.__mainProductGeneralInit) return;
  window.__mainProductGeneralInit = true;

  function toArray(nodes) {
    return Array.prototype.slice.call(nodes || []);
  }

  function getMediaRoot(section) {
    return section.querySelector('[data-mpg-media-root]');
  }

  function getMediaMode(section) {
    var root = getMediaRoot(section);
    return root ? root.getAttribute('data-mpg-media-mode') || 'image' : 'image';
  }

  function getMediaCounts(section) {
    return section.__mpgGeneralMediaCounts || { image: 0, video: 0 };
  }

  function getLastMediaIndex(section, mode) {
    var map = section.__mpgGeneralLastMediaIndex || { image: 0, video: 0 };
    section.__mpgGeneralLastMediaIndex = map;
    return Number(map[mode] || 0);
  }

  function setLastMediaIndex(section, mode, index) {
    var map = section.__mpgGeneralLastMediaIndex || { image: 0, video: 0 };
    map[mode] = Number.isFinite(index) ? index : 0;
    section.__mpgGeneralLastMediaIndex = map;
  }

  function getMediaSwiper(section, mode) {
    return mode === 'video' ? section.__mpgGeneralVideoSwiper : section.__mpgGeneralImageSwiper;
  }

  function updateVideoEntryPreviewState(section) {
    if (!section) return;
    var previewVideo = section.querySelector('.mpgGeneral__videoEntryPreviewVideo');
    if (!previewVideo) return;

    var isVideoMode = getMediaMode(section) === 'video';
    var isInView = section.__mpgGeneralVideoEntryInView !== false;
    if (isVideoMode || !isInView) {
      if (!previewVideo.paused) previewVideo.pause();
      return;
    }

    var playPromise = previewVideo.play && previewVideo.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function pauseInactiveMedia(section, activeMode, activeIndex) {
    ['image', 'video'].forEach(function (mode) {
      var gallery = section.querySelector('[data-mpg-general-swiper="' + mode + '"]');
      if (!gallery) return;

      toArray(gallery.querySelectorAll('video')).forEach(function (video, index) {
        if (mode !== activeMode || index !== activeIndex) {
          if (!video.paused) video.pause();
        }
      });
    });
  }

  function updateMediaNav(section, mode) {
    var counts = getMediaCounts(section);
    var total = mode === 'video' ? counts.video : counts.image;
    var disabled = total <= 1;

    toArray(section.querySelectorAll('[data-mpg-general-prev], [data-mpg-general-next]')).forEach(function (button) {
      button.disabled = disabled;
    });
  }

  function updateActiveEntries(section, mode, activeIndex) {
    var counts = getMediaCounts(section);
    var total = mode === 'video' ? counts.video : counts.image;
    var safeIndex = activeIndex;
    if (!Number.isFinite(safeIndex) || safeIndex < 0) safeIndex = 0;

    toArray(section.querySelectorAll('[data-mpg-general-kind="image"]')).forEach(function (button) {
      var isActive = mode === 'image' && Number(button.getAttribute('data-mpg-general-target-index')) === safeIndex;
      button.classList.toggle('is-active', isActive);
      if (isActive && button.scrollIntoView) {
        button.scrollIntoView({ inline: 'center', block: 'nearest' });
      }
    });

    toArray(section.querySelectorAll('[data-mpg-general-kind="video"]')).forEach(function (button) {
      var isActive = mode === 'video' && Number(button.getAttribute('data-mpg-general-target-index')) === safeIndex;
      button.classList.toggle('is-active', isActive);
      if (isActive && button.scrollIntoView) {
        button.scrollIntoView({ inline: 'nearest', block: 'nearest' });
      }
    });

    var currentElement = section.querySelector('[data-mpg-general-current]');
    var totalElement = section.querySelector('[data-mpg-general-total]');
    if (currentElement) {
      currentElement.textContent = String(total > 0 ? safeIndex + 1 : 0);
    }
    if (totalElement) {
      totalElement.textContent = String(total);
    }

    updateMediaNav(section, mode);
  }

  function updateMediaModeTabs(section, mode) {
    var tabs = section.querySelector('[data-mpg-general-mode-tabs]');
    if (tabs) {
      tabs.style.setProperty('--mpg-media-tab-index', mode === 'video' ? 1 : 0);
    }

    toArray(section.querySelectorAll('[data-mpg-general-mode-tab]')).forEach(function (btn) {
      var isActive = (btn.getAttribute('data-mpg-general-mode-tab') || '') === mode;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  function syncActiveMediaUi(section, mode) {
    var swiper = getMediaSwiper(section, mode);
    var activeIndex = swiper ? swiper.activeIndex : 0;
    updateActiveEntries(section, mode, activeIndex);
    updateMediaModeTabs(section, mode);
    pauseInactiveMedia(section, mode, activeIndex);
    updateVideoEntryPreviewState(section);
  }

  function setActiveMediaMode(section, mode, targetIndex) {
    var root = getMediaRoot(section);
    if (root) root.setAttribute('data-mpg-media-mode', mode);

    ['image', 'video'].forEach(function (type) {
      var gallery = section.querySelector('[data-mpg-general-swiper="' + type + '"]');
      if (!gallery) return;
      var isActive = type === mode;
      gallery.classList.toggle('is-active', isActive);
      gallery.classList.toggle('is-hidden', !isActive);
    });

    var swiper = getMediaSwiper(section, mode);
    var shouldMove = Number.isFinite(targetIndex);

    if (swiper && typeof swiper.update === 'function') {
      swiper.update();
      if (shouldMove && swiper.activeIndex !== targetIndex) {
        swiper.slideTo(targetIndex);
        return;
      }
    }

    syncActiveMediaUi(section, mode);
  }

  function getInitialImageIndex(section) {
    if (!section) return 0;
    var raw = section.getAttribute('data-mpg-initial-image-index');
    var index = parseInt(raw, 10);
    return Number.isFinite(index) && index >= 0 ? index : 0;
  }

  function initThumbScroll(section) {
    if (section.__mpgGeneralThumbScrollBound) return;
    section.__mpgGeneralThumbScrollBound = true;

    var rail = section.querySelector('[data-mpg-general-image-rail]');
    if (!rail) return;

    toArray(section.querySelectorAll('[data-mpg-general-thumb-scroll]')).forEach(function (button) {
      button.addEventListener('click', function () {
        var direction = button.getAttribute('data-mpg-general-thumb-scroll') === 'next' ? 1 : -1;
        rail.scrollBy({ left: direction * 220, behavior: 'smooth' });
      });
    });
  }

  function initImageLightbox(section) {
    if (!section || section.__mpgGeneralLightboxBound) return;

    var lightbox = section.querySelector('[data-mpg-lightbox]');
    var lightboxSwiperEl = section.querySelector('[data-mpg-lightbox-swiper]');
    if (!lightbox || !lightboxSwiperEl) return;

    if (typeof Swiper === 'undefined') {
      return;
    }
    section.__mpgGeneralLightboxBound = true;

    var lockClass = 'mpgGeneralLightboxBodyLock';
    var lightboxSwiper = new Swiper(lightboxSwiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 320,
      on: {
        slideChange: function () {
          var imageSwiper = getMediaSwiper(section, 'image');
          if (!imageSwiper) return;
          if (imageSwiper.activeIndex !== this.activeIndex) {
            imageSwiper.slideTo(this.activeIndex);
          }
        }
      }
    });
    section.__mpgGeneralLightboxSwiper = lightboxSwiper;

    function openAt(index) {
      var imageSwiper = getMediaSwiper(section, 'image');
      var target = Number.isFinite(index) ? index : imageSwiper ? imageSwiper.activeIndex : 0;
      if (!Number.isFinite(target) || target < 0) target = 0;

      lightbox.removeAttribute('hidden');
      document.body.classList.add(lockClass);
      document.documentElement.classList.add(lockClass);
      lightboxSwiper.slideTo(target, 0);
    }

    function close() {
      lightbox.setAttribute('hidden', '');
      document.body.classList.remove(lockClass);
      document.documentElement.classList.remove(lockClass);
    }

    section.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-mpg-lightbox-open]');
      if (!opener || !section.contains(opener)) return;

      event.preventDefault();
      if (getMediaMode(section) !== 'image') return;
      openAt(Number(opener.getAttribute('data-mpg-lightbox-open')));
    });

    section.addEventListener('keydown', function (event) {
      var opener = event.target.closest('[data-mpg-lightbox-open]');
      if (!opener || !section.contains(opener)) return;
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      if (getMediaMode(section) !== 'image') return;
      openAt(Number(opener.getAttribute('data-mpg-lightbox-open')));
    });

    lightbox.addEventListener('click', function (event) {
      if (event.target.closest('[data-mpg-lightbox-close]')) {
        close();
        return;
      }
      if (event.target.closest('[data-mpg-lightbox-prev]')) {
        lightboxSwiper.slidePrev();
        return;
      }
      if (event.target.closest('[data-mpg-lightbox-next]')) {
        lightboxSwiper.slideNext();
        return;
      }
      if (!event.target.closest('.mpgGeneralLightbox__slide') && !event.target.closest('.mpgGeneralLightbox__nav')) {
        close();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !lightbox.hasAttribute('hidden')) {
        close();
      }
    });
  }

  function initVideoEntryPreviewControl(section) {
    if (!section || section.__mpgGeneralVideoEntryPreviewBound) return;
    section.__mpgGeneralVideoEntryPreviewBound = true;

    var previewVideo = section.querySelector('.mpgGeneral__videoEntryPreviewVideo');
    if (!previewVideo) return;

    section.__mpgGeneralVideoEntryInView = true;

    if (typeof IntersectionObserver === 'undefined') {
      updateVideoEntryPreviewState(section);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries && entries[0];
        if (!entry) return;
        section.__mpgGeneralVideoEntryInView = !!entry.isIntersecting;
        updateVideoEntryPreviewState(section);
      },
      { threshold: 0.1 }
    );

    observer.observe(previewVideo);
    section.__mpgGeneralVideoEntryPreviewObserver = observer;
    updateVideoEntryPreviewState(section);
  }

  function initMediaGallery(section) {
    if (section.__mpgGeneralMediaInit) return true;

    var imageSwiperEl = section.querySelector('[data-mpg-general-swiper="image"]');
    var videoSwiperEl = section.querySelector('[data-mpg-general-swiper="video"]');
    if (!imageSwiperEl && !videoSwiperEl) {
      section.__mpgGeneralMediaInit = true;
      return true;
    }

    if (typeof Swiper === 'undefined') {
      return false;
    }

    section.__mpgGeneralMediaCounts = {
      image: imageSwiperEl ? imageSwiperEl.querySelectorAll('.swiper-slide').length : 0,
      video: videoSwiperEl ? videoSwiperEl.querySelectorAll('.swiper-slide').length : 0
    };

    function bindSwiper(swiperEl, mode) {
      if (!swiperEl) return null;
      return new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 450,
        on: {
          init: function () {
            if (getMediaMode(section) === mode) {
              syncActiveMediaUi(section, mode);
            }
          },
          slideChange: function () {
            if (getMediaMode(section) === mode) {
              setLastMediaIndex(section, mode, this.activeIndex);
              syncActiveMediaUi(section, mode);
            } else {
              pauseInactiveMedia(section, getMediaMode(section), getMediaSwiper(section, getMediaMode(section)) ? getMediaSwiper(section, getMediaMode(section)).activeIndex : 0);
            }
          }
        }
      });
    }

    section.__mpgGeneralImageSwiper = bindSwiper(imageSwiperEl, 'image');
    section.__mpgGeneralVideoSwiper = bindSwiper(videoSwiperEl, 'video');

    toArray(section.querySelectorAll('[data-mpg-general-mode-tab]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mode = btn.getAttribute('data-mpg-general-mode-tab') === 'video' ? 'video' : 'image';
        var remembered = getLastMediaIndex(section, mode);
        setActiveMediaMode(section, mode, remembered);
      });
    });

    toArray(section.querySelectorAll('[data-mpg-general-kind="image"]')).forEach(function (button) {
      button.addEventListener('click', function () {
        var targetIndex = Number(button.getAttribute('data-mpg-general-target-index'));
        setLastMediaIndex(section, 'image', targetIndex);
        setActiveMediaMode(section, 'image', targetIndex);
      });
    });

    toArray(section.querySelectorAll('[data-mpg-general-kind="video"]')).forEach(function (button) {
      button.addEventListener('click', function () {
        var targetIndex = Number(button.getAttribute('data-mpg-general-target-index'));
        setLastMediaIndex(section, 'video', targetIndex);
        setActiveMediaMode(section, 'video', targetIndex);
      });
    });

    toArray(section.querySelectorAll('[data-mpg-general-prev], [data-mpg-general-next]')).forEach(function (button) {
      button.addEventListener('click', function () {
        var mode = getMediaMode(section);
        var swiper = getMediaSwiper(section, mode);
        if (!swiper) return;

        if (button.hasAttribute('data-mpg-general-prev')) {
          swiper.slidePrev();
        } else {
          swiper.slideNext();
        }
      });
    });

    section.__mpgGeneralMediaInit = true;
    var initialMode = getMediaMode(section);
    var initialIndex = initialMode === 'image' ? getInitialImageIndex(section) : getLastMediaIndex(section, initialMode);
    setLastMediaIndex(section, initialMode, initialIndex);
    setActiveMediaMode(section, initialMode, initialIndex);
    return true;
  }

  function initPromoCopy(section) {
    if (section.__mpgGeneralCopyBound) return;
    section.__mpgGeneralCopyBound = true;

    function fallbackCopy(text) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
    }

    section.addEventListener('click', function (event) {
      var button = event.target.closest('[data-copy-discount-code]');
      if (!button) return;

      var code = button.getAttribute('data-code') || '';
      if (!code) return;

      var copiedLabel = button.getAttribute('data-copied-label') || 'Copied';
      var defaultLabel = button.getAttribute('data-default-label') || 'Copy code';

      var finish = function () {
        button.textContent = copiedLabel;
        clearTimeout(button.__copyResetTimer);
        button.__copyResetTimer = setTimeout(function () {
          button.textContent = defaultLabel;
        }, 1600);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(finish).catch(function () {
          fallbackCopy(code);
          finish();
        });
      } else {
        fallbackCopy(code);
        finish();
      }
    });
  }

  function refreshDescriptionCard(card) {
    if (!card) return;

    var content = card.querySelector('[data-mpg-desc-content]');
    var toggle = card.querySelector('[data-mpg-desc-toggle]');
    var toggleText = card.querySelector('[data-mpg-desc-toggle-text]');
    if (!content || !toggle) return;

    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    if (!expanded) {
      content.classList.add('is-collapsed');
    }

    var shouldShowToggle = content.scrollHeight - content.clientHeight > 1;
    toggle.hidden = !shouldShowToggle;

    if (!shouldShowToggle) {
      toggle.setAttribute('aria-expanded', 'false');
      content.classList.add('is-collapsed');
      if (toggleText) toggleText.textContent = 'Mehr anzeigen';
    } else if (toggleText) {
      toggleText.textContent = expanded ? 'Weniger anzeigen' : 'Mehr anzeigen';
    }
  }

  function initDescriptionToggle(section) {
    if (!section || section.__mpgGeneralDescBound) return;
    section.__mpgGeneralDescBound = true;

    function refreshAll() {
      toArray(section.querySelectorAll('[data-mpg-desc-card]')).forEach(refreshDescriptionCard);
    }

    refreshAll();

    section.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-mpg-desc-toggle]');
      if (!toggle) return;

      var card = toggle.closest('[data-mpg-desc-card]');
      var content = card && card.querySelector('[data-mpg-desc-content]');
      var toggleText = card && card.querySelector('[data-mpg-desc-toggle-text]');
      if (!card || !content) return;

      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      content.classList.toggle('is-collapsed', expanded);
      if (toggleText) toggleText.textContent = expanded ? 'Mehr anzeigen' : 'Weniger anzeigen';
    });

    toArray(section.querySelectorAll('[data-mpg-desc-card]')).forEach(function (card) {
      var content = card.querySelector('[data-mpg-desc-content]');
      if (!content) return;

      var observer = new MutationObserver(function () {
        window.requestAnimationFrame(function () {
          refreshDescriptionCard(card);
        });
      });

      observer.observe(content, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });
  }

  function initPurchaseQuantityButtons(section) {
    if (!section || section.__mpgGeneralQtyBound) return;
    section.__mpgGeneralQtyBound = true;

    function resolveVariantForQuantity() {
      var variants = readVariantsFromDom() || [];
      return getSelectedVariant(section, variants);
    }

    section.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest('.mpgGeneral__qtyButton');
        if (!button) return;
        if (!section.contains(button)) return;

        var quantityWrap = button.closest('quantity-input');
        var input = quantityWrap && quantityWrap.querySelector('.mpgGeneral__quantityInput');
        if (!input || input.disabled) return;

        var variant = resolveVariantForQuantity();
        if (!variant) return;

        event.preventDefault();
        event.stopPropagation();

        var previous = Number(input.value) || 1;
        if (button.name === 'plus') {
          input.stepUp();
        } else {
          input.stepDown();
        }

        var next = normalizeQuantityInput(section, input, variant, { showWarning: true });

        if (next !== previous) {
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      },
      true
    );

    section.addEventListener(
      'change',
      function (event) {
        var input = event.target;
        if (!input || input.name !== 'quantity') return;
        if (!section.contains(input) || !input.classList.contains('mpgGeneral__quantityInput')) return;

        var variant = resolveVariantForQuantity();
        if (!variant) return;

        normalizeQuantityInput(section, input, variant, { showWarning: true });
      },
      true
    );
  }

  function updateStickyState(section, isVisible) {
    var sticky = section.querySelector('[data-mpg-sticky]');
    if (!sticky) return;
    sticky.classList.toggle('is-visible', !!isVisible);
  }

  function getSectionProductId(section) {
    if (!section) return '';

    var qtyInput = section.querySelector('.mpgGeneral__quantityInput[data-product]');
    if (qtyInput) {
      return qtyInput.getAttribute('data-product') || '';
    }

    var priceWrap = section.querySelector('[data-mpg-product-id]');
    if (priceWrap) {
      return priceWrap.getAttribute('data-mpg-product-id') || '';
    }

    return '';
  }

  function getVariantInventoryQuantity(section, variant) {
    if (!variant) return null;

    var directQty = Number(variant.inventory_quantity);
    if (Number.isFinite(directQty)) {
      return directQty;
    }

    var productId = getSectionProductId(section);
    if (!productId) return null;

    var inventoryMap = window['product_inven_array_' + productId];
    if (!inventoryMap) return null;

    var fallbackQty = Number(inventoryMap[String(variant.id)]);
    return Number.isFinite(fallbackQty) ? fallbackQty : null;
  }

  function setQuantityState(section, disabled) {
    if (!section) return;

    toArray(section.querySelectorAll('.mpgGeneral__quantityInput')).forEach(function (input) {
      input.disabled = !!disabled;
    });

    toArray(section.querySelectorAll('.mpgGeneral__qtyButton')).forEach(function (button) {
      button.disabled = !!disabled;
    });
  }

  function getVariantInventoryPolicy(section, variant) {
    if (!variant) return null;

    if (variant.inventory_policy) {
      return variant.inventory_policy;
    }

    var productId = getSectionProductId(section);
    if (!productId) return null;

    var policyMap = window['selling_array_' + productId];
    if (!policyMap) return null;

    return policyMap[String(variant.id)] || null;
  }

  function allowsQuantityAboveInventory(section, variant) {
    if (!variant || !variant.available) return false;
    return getVariantInventoryPolicy(section, variant) === 'continue';
  }

  function showMpgQuantityWarning(maxValue) {
    if (!window.cartStrings || !window.cartStrings.addProductOutQuantity) return;

    var message = window.cartStrings.addProductOutQuantity.replace('[maxQuantity]', maxValue);

    if (typeof showWarning === 'function') {
      showWarning(message, 3000);
      return;
    }

    if (window.halo && typeof window.halo.showWarning === 'function') {
      window.halo.showWarning(message, 3000);
    }
  }

  function normalizeQuantityInput(section, input, variant, options) {
    options = options || {};
    if (!input || !variant) return 1;

    var value = parseInt(input.value, 10);
    if (!Number.isFinite(value) || value < 1) {
      value = 1;
    }

    var maxValue = getVariantInventoryQuantity(section, variant);
    if (!Number.isFinite(maxValue)) {
      maxValue = parseInt(input.getAttribute('data-inventory-quantity'), 10);
    }

    var allowOutOfStock = allowsQuantityAboveInventory(section, variant);

    if (Number.isFinite(maxValue) && maxValue > 0 && value > maxValue && !allowOutOfStock) {
      value = maxValue;
      if (options.showWarning) {
        showMpgQuantityWarning(maxValue);
      }
    }

    input.value = String(value);
    return value;
  }

  function syncQuantityForVariant(section, variant) {
    if (!section || !variant) return null;

    var qtyInput = section.querySelector('form[data-type="add-to-cart-form"] input[name="quantity"]');
    if (!qtyInput) return null;

    var previousId = section.__mpgGeneralLastVariantId;
    var variantChanged = previousId != null && String(previousId) !== String(variant.id);
    section.__mpgGeneralLastVariantId = variant.id;

    var qty = normalizeQuantityInput(section, qtyInput, variant, {
      showWarning: variantChanged
    });

    var stickyQty = section.querySelector('[data-mpg-sticky-qty]');
    if (stickyQty) {
      stickyQty.value = String(qty);
    }

    return qty;
  }

  function updateButtonUnavailableState(button) {
    if (!button) return;

    var soldOutLabel = button.getAttribute('data-label-soldout') || 'Sold out';
    var section = button.closest('[data-main-product-general]');

    button.disabled = true;
    button.setAttribute('data-available', 'false');
    button.removeAttribute('data-inventory-quantity');
    button.textContent = soldOutLabel;

    setQuantityState(section, true);
  }

  function updateButtonState(button, variant) {
    if (!button) return;
    if (!variant) {
      updateButtonUnavailableState(button);
      return;
    }

    var addLabel = button.getAttribute('data-label-add') || 'Add to cart';
    var preOrderLabel = button.getAttribute('data-label-preorder') || 'Pre-order';
    var soldOutLabel = button.getAttribute('data-label-soldout') || 'Sold out';
    var section = button.closest('[data-main-product-general]');
    var qtyInput = section && section.querySelector('.mpgGeneral__quantityInput');
    var inventoryQty = getVariantInventoryQuantity(section, variant);
    var hasInventoryQty = Number.isFinite(inventoryQty);
    var isAvailable = !!variant.available;
    var inventoryPolicy = getVariantInventoryPolicy(section, variant);
    var isPreOrder =
      isAvailable &&
      !!variant.inventory_management &&
      inventoryPolicy === 'continue' &&
      hasInventoryQty &&
      inventoryQty <= 0;

    if (qtyInput && hasInventoryQty) {
      qtyInput.setAttribute('data-inventory-quantity', String(inventoryQty));
      qtyInput.dataset.inventoryQuantity = String(inventoryQty);
    }

    setQuantityState(section, !isAvailable);
    button.disabled = !isAvailable;
    if (hasInventoryQty) {
      button.setAttribute('data-inventory-quantity', String(inventoryQty));
    } else {
      button.removeAttribute('data-inventory-quantity');
    }
    button.setAttribute('data-available', isPreOrder ? 'true' : 'false');
    button.textContent = !isAvailable ? soldOutLabel : isPreOrder ? preOrderLabel : addLabel;
  }

  function updateNotifyState(section, variant) {
    if (!section) return;

    var notifyWrap = section.querySelector('.productView-notifyMe');
    if (!notifyWrap) return;
    var shouldShow = !!variant && !variant.available;

    var variantInput = notifyWrap.querySelector('.halo-notify-product-variant');
    if (variantInput && variant) {
      variantInput.value = variant.title || '';
    }

    var notifyText = notifyWrap.querySelector('.notifyMe-text');
    if (notifyText) {
      notifyText.textContent = '';
    }

    if (window.jQuery && typeof window.jQuery === 'function') {
      window.jQuery(notifyWrap).stop(true, true)[shouldShow ? 'slideDown' : 'slideUp']('slow');
      return;
    }

    notifyWrap.style.display = shouldShow ? '' : 'none';
  }

  function updateOptionLabels(section) {
    var radiosRoot = section.querySelector('variant-radios.mpgGeneral__variantRadios');
    if (!radiosRoot) return;

    toArray(radiosRoot.querySelectorAll('.mpgGeneral__optionField')).forEach(function (fieldset) {
      var checked = fieldset.querySelector('.mpgGeneral__optionInput:checked');
      var header = fieldset.querySelector('[data-header-option]');
      if (checked && header) {
        header.textContent = checked.value;
      }
    });
  }

  function getOptionSoldOutLabel(section) {
    var radiosRoot = section.querySelector('variant-radios.mpgGeneral__variantRadios');
    var addButton = section.querySelector('.mpgGeneral__addToCart[data-btn-addToCart]');

    return (
      (radiosRoot && radiosRoot.getAttribute('data-label-soldout')) ||
      (addButton && addButton.getAttribute('data-label-soldout')) ||
      'Sold out'
    );
  }

  function getOptionState(section, variants, optionIndex, optionValue, selectedValues) {
    var matchingVariants = (variants || []).filter(function (variant) {
      if ((variant['option' + (optionIndex + 1)] || null) !== optionValue) return false;

      for (var index = 0; index < optionIndex; index += 1) {
        if (selectedValues[index] && (variant['option' + (index + 1)] || null) !== selectedValues[index]) {
          return false;
        }
      }

      return true;
    });

    if (!matchingVariants.length) {
      return 'soldout';
    }

    return matchingVariants.some(function (variant) {
      return !!variant.available;
    })
      ? 'available'
      : 'soldout';
  }

  function syncOptionValueStates(section, variants) {
    var radiosRoot = section.querySelector('variant-radios.mpgGeneral__variantRadios');
    if (!radiosRoot || !variants || !variants.length) return;

    var selectedValues = toArray(radiosRoot.querySelectorAll('.mpgGeneral__optionField')).map(function (fieldset) {
      var checked = fieldset.querySelector('.mpgGeneral__optionInput:checked');
      return checked ? checked.value : null;
    });
    var soldOutLabel = getOptionSoldOutLabel(section);

    toArray(radiosRoot.querySelectorAll('.mpgGeneral__optionField')).forEach(function (fieldset, optionIndex) {
      toArray(fieldset.querySelectorAll('.mpgGeneral__optionInput')).forEach(function (input) {
        var label = fieldset.querySelector('label[for="' + input.id + '"]');
        if (!label) return;

        var state = getOptionState(section, variants, optionIndex, input.value, selectedValues);
        var badge = label.querySelector('[data-option-status-badge]');

        label.classList.remove('available', 'soldout');
        label.classList.add(state);
        label.setAttribute('data-option-stock-state', state);

        if (badge) {
          if (state === 'soldout') {
            badge.textContent = soldOutLabel;
            badge.hidden = false;
          } else {
            badge.textContent = '';
            badge.hidden = true;
          }
        }
      });
    });
  }

  function syncMainVariantPicker(section, variant) {
    var radiosRoot = section.querySelector('variant-radios.mpgGeneral__variantRadios');
    if (!radiosRoot || !variant) return false;

    var optionValues = [variant.option1, variant.option2, variant.option3];
    var changedInput = null;

    toArray(radiosRoot.querySelectorAll('.mpgGeneral__optionField')).forEach(function (fieldset, index) {
      var optionValue = optionValues[index];
      if (!optionValue) return;

      var targetInput = toArray(fieldset.querySelectorAll('.mpgGeneral__optionInput')).find(function (input) {
        return input.value === optionValue;
      });

      if (targetInput) {
        if (!targetInput.checked) {
          targetInput.checked = true;
          changedInput = targetInput;
        }
        var header = fieldset.querySelector('[data-header-option]');
        if (header) header.textContent = optionValue;
      }
    });

    if (changedInput) {
      changedInput.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    return false;
  }

  function updateStickyPrice(section, variant, quantity) {
    var sticky = section.querySelector('[data-mpg-sticky]');
    if (!sticky) return;

    var currentEl = sticky.querySelector('[data-mpg-sticky-current]');
    var compareEl = sticky.querySelector('[data-mpg-sticky-compare]');
    var discountEl = sticky.querySelector('[data-mpg-sticky-discount]');
    if (!currentEl || !compareEl || !discountEl || !variant) return;

    var qty = Number(quantity);
    if (!Number.isFinite(qty) || qty < 1) qty = 1;

    var linePrice = Number(variant.price || 0) * qty;
    var compareAt = Number(variant.compare_at_price || 0);
    var lineCompare = compareAt * qty;
    var hasDiscount = compareAt > Number(variant.price || 0);

    currentEl.textContent = formatMoney(linePrice);
    setHidden(compareEl, !hasDiscount);
    setHidden(discountEl, !hasDiscount);
    if (hasDiscount) {
      compareEl.textContent = formatMoney(lineCompare);
      discountEl.textContent = '-' + formatMoney(lineCompare - linePrice);
    }
  }

  function updateStickyEtaVisibility(section, variant) {
    var sticky = section.querySelector('[data-mpg-sticky]');
    if (!sticky) return;

    // Metafield delivery text always shows; inventory gate only applies when empty.
    var hasCustomDelivery = sticky.getAttribute('data-has-custom-delivery') === 'true';
    var shouldHide = false;
    if (!hasCustomDelivery) {
      var inventoryQty = getVariantInventoryQuantity(section, variant);
      shouldHide = Number.isFinite(inventoryQty) && inventoryQty <= 0;
    }

    toArray(sticky.querySelectorAll('[data-mpg-sticky-eta-wrap]')).forEach(function (wrap) {
      if (shouldHide) {
        wrap.style.display = 'none';
      } else {
        wrap.style.removeProperty('display');
      }
    });
  }

  function updateStickyButtons(section, variant) {
    var sticky = section.querySelector('[data-mpg-sticky]');
    if (!sticky) return;

    var addBtn = sticky.querySelector('[data-mpg-sticky-add]');
    var idInput = sticky.querySelector('[data-mpg-sticky-id]');
    var qtyInput = sticky.querySelector('[data-mpg-sticky-qty]');
    var select = sticky.querySelector('[data-mpg-sticky-variant-select]');
    var mainQtyInput = section.querySelector('form[data-type="add-to-cart-form"] input[name="quantity"]');

    if (!variant) {
      if (addBtn) {
        updateButtonState(addBtn, null);
      }
      return;
    }

    if (idInput) idInput.value = variant.id;
    if (select) select.value = String(variant.id);
    if (qtyInput && mainQtyInput) qtyInput.value = String(Number(mainQtyInput.value) || 1);

    if (addBtn) {
      updateButtonState(addBtn, variant);
    }
  }

  function updateMainPurchaseButton(section, variant) {
    var mainAddBtn = section.querySelector('.mpgGeneral__purchaseCard .mpgGeneral__addToCart[data-btn-addToCart]');
    if (mainAddBtn) {
      updateButtonState(mainAddBtn, variant);
    }
  }

  function updateStickyVariantSelect(section, variant) {
    var sticky = section.querySelector('[data-mpg-sticky]');
    if (!sticky || !variant) return;

    var select = sticky.querySelector('[data-mpg-sticky-variant-select]');
    var idInput = sticky.querySelector('[data-mpg-sticky-id]');
    if (select) select.value = String(variant.id);
    if (idInput) idInput.value = String(variant.id);
  }

  function syncMainAndSticky(section, variants) {
    var variant = getSelectedVariant(section, variants);
    if (!variant) return;

    syncOptionValueStates(section, variants);
    updateMainPurchaseButton(section, variant);
    updateNotifyState(section, variant);
    updateStickyVariantSelect(section, variant);
    updatePriceUi(section, variant);
    updatePurchaseTotals(section, variant);
    updateStickyPrice(section, variant, (section.querySelector('form[data-type="add-to-cart-form"] input[name="quantity"]') || {}).value);
    updateStickyEtaVisibility(section, variant);
    updateStickyButtons(section, variant);
  }

  function initStickyBar(section) {
    if (!section || section.__mpgGeneralStickyBound) return;
    section.__mpgGeneralStickyBound = true;

    var sticky = section.querySelector('[data-mpg-sticky]');
    if (!sticky) return;
    var purchaseButtons = section.querySelector('.mpgGeneral__purchaseButtons') || section.querySelector('[data-mpg-purchase]');

    var variants = readVariantsFromDom() || [];
    function getCurrentVariant() {
      var id = getSelectedVariantId(section);
      return variants.find(function (v) {
        return Number(v.id) === Number(id);
      });
    }

    function syncSticky() {
      syncMainAndSticky(section, variants);
    }

    var io = new IntersectionObserver(
      function (entries) {
        var entry = entries && entries[0];
        if (!entry) return;
        updateStickyState(section, !entry.isIntersecting);
      },
      { threshold: 0.05 }
    );
    io.observe(purchaseButtons);
    section.__mpgGeneralStickyObserver = io;

    sticky.addEventListener('change', function (event) {
      var select = event.target.closest('[data-mpg-sticky-variant-select]');
      if (!select) return;
      var nextId = Number(select.value);
      var variant = variants.find(function (v) {
        return Number(v.id) === nextId;
      });
      if (!variant) return;

      var changed = syncMainVariantPicker(section, variant);
      if (changed) return;

      var mainForm = section.querySelector('form[data-type="add-to-cart-form"]');
      var mainIdInput = mainForm && mainForm.querySelector('input[name="id"]');
      if (mainIdInput) {
        mainIdInput.value = String(nextId);
        mainIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      window.requestAnimationFrame(syncSticky);
    });

    section.addEventListener('change', function (event) {
      var target = event.target;
      if (!target) return;
      if (target.name === 'quantity' || target.name === 'id' || target.closest('variant-radios') || target.closest('variant-selects')) {
        window.requestAnimationFrame(syncSticky);
      }
    });
    section.addEventListener('input', function (event) {
      var target = event.target;
      if (target && target.name === 'quantity') {
        window.requestAnimationFrame(syncSticky);
      }
    });

    syncSticky();
  }

  function initStickyDelivery(section) {
    if (!section || section.__mpgGeneralStickyDeliveryBound) return;
    section.__mpgGeneralStickyDeliveryBound = true;

    var labels = toArray(section.querySelectorAll('[data-mpg-sticky-delivery-label]'));
    var texts = toArray(section.querySelectorAll('[data-mpg-sticky-delivery-text]'));
    if (!labels.length || !texts.length) return;

    function getFutureDateRange(startOffset, rangeDays, locale) {
      var today = new Date();
      var startDate = new Date(today);
      startDate.setDate(today.getDate() + startOffset);
      var endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + rangeDays - 1);

      var options = { month: 'short', day: 'numeric' };
      return (
        startDate.toLocaleDateString(locale, options) +
        ' - ' +
        endDate.toLocaleDateString(locale, options)
      );
    }

    var shippingTimeMap = {
      US: { title: 'Estimated Shipping Date', locale: 'en-US', startOffset: 0, rangeDays: 3 },
      DE: { title: 'Geschatztes Lieferdatum', locale: 'de-DE', startOffset: 3, rangeDays: 5 },
      FR: { title: "Delai d'expedition estime", locale: 'fr-FR', startOffset: 0, rangeDays: 3 },
      EU: { title: 'Estimated Shipping Date', locale: 'en-GB', startOffset: 0, rangeDays: 4 },
      CA: { title: 'Estimated Delivery Date', locale: 'en-CA', startOffset: 3, rangeDays: 5 },
      AU: { title: 'Estimated Shipping Date', locale: 'en-AU', startOffset: 0, rangeDays: 3 },
      UK: { title: 'Estimated Delivery Date', locale: 'en-GB', startOffset: 3, rangeDays: 5 }
    };

    var aliases = { GB: 'UK' };
    var countryCode = (texts[0].getAttribute('data-delivery-country') || 'US').toUpperCase();
    countryCode = aliases[countryCode] || countryCode;
    var shipping = shippingTimeMap[countryCode] || shippingTimeMap.US;

    labels.forEach(function (label) {
      label.textContent = shipping.title + ':';
    });

    var hasCustomText = texts[0].textContent && texts[0].textContent.trim();
    if (hasCustomText) return;

    var generated = getFutureDateRange(shipping.startOffset, shipping.rangeDays, shipping.locale);
    texts.forEach(function (text) {
      text.textContent = generated;
    });
  }

  function initSection(section) {
    if (!section || section.__mainProductGeneralSectionInit) return;

    initThumbScroll(section);
    initPromoCopy(section);
    initDescriptionToggle(section);
    initPurchaseQuantityButtons(section);
    initPrice(section);
    initStickyBar(section);
    initStickyDelivery(section);
    if (!initMediaGallery(section)) {
      clearTimeout(section.__mainProductGeneralSwiperTimer);
      section.__mainProductGeneralSwiperTimer = window.setTimeout(function () {
        initSection(section);
      }, 120);
      return;
    }
    initVideoEntryPreviewControl(section);
    initImageLightbox(section);

    section.__mainProductGeneralSectionInit = true;
  }

  function initAll(root) {
    toArray((root || document).querySelectorAll('[data-main-product-general]')).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  function readVariantsFromDom() {
    var script = document.querySelector('[data-mpg-general-variants]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent || '[]');
    } catch (e) {
      return null;
    }
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney && window.money_format) {
      return Shopify.formatMoney(cents, window.money_format);
    }
    return String(cents);
  }

  function setHidden(el, hidden) {
    if (!el) return;
    if (hidden) el.setAttribute('hidden', '');
    else el.removeAttribute('hidden');
  }

  function updateVariantUrl(section, variant) {
    if (
      !section ||
      !variant ||
      !window.history ||
      typeof window.history.replaceState !== 'function'
    ) {
      return;
    }

    // 与旧模板 variants.js 一致：没有变体选择器时不改 URL。
    // 仅 Default Title 的产品不会渲染 variant-radios。
    var radiosRoot = section.querySelector('variant-radios.mpgGeneral__variantRadios');
    if (!radiosRoot) return;

    var baseUrl = radiosRoot.getAttribute('data-url');

    try {
      var nextUrl = new URL(window.location.href);
      if (baseUrl) {
        var resolvedBaseUrl = new URL(baseUrl, window.location.origin);
        nextUrl.pathname = resolvedBaseUrl.pathname;
      }

      nextUrl.searchParams.set('variant', String(variant.id));

      var nextPath = nextUrl.pathname + nextUrl.search + nextUrl.hash;
      var currentPath = window.location.pathname + window.location.search + window.location.hash;

      if (nextPath !== currentPath) {
        window.history.replaceState({}, '', nextPath);
      }
    } catch (e) {}
  }

  function updateInstallmentForms(section, variant) {
    if (!variant) return;

    toArray(section.querySelectorAll('[data-product-installment-id]')).forEach(function (input) {
      var nextId = String(variant.id);
      if (input.value === nextId) return;
      input.value = nextId;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function updateKlarnaMessages(section, variant) {
    if (!variant || typeof variant.price !== 'number') return;
    toArray(section.querySelectorAll('klarna-placement')).forEach(function (el) {
      el.setAttribute('data-purchase-amount', String(variant.price));
    });

    if (window.KlarnaOnsiteService && typeof window.KlarnaOnsiteService.push === 'function') {
      try {
        window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
      } catch (e) {}
    }
  }

  function updateAffirmMessages(section, variant) {
    if (!variant || typeof variant.price !== 'number') return;

    toArray(section.querySelectorAll('.affirm-as-low-as[data-page-type="product"]')).forEach(function (el) {
      el.setAttribute('data-amount', String(variant.price));
    });

    if (typeof window.affirm !== 'undefined' && window.affirm.ui) {
      try {
        if (typeof window.affirm.ui.refresh === 'function') {
          window.affirm.ui.refresh();
        } else if (typeof window.affirm.ui.ready === 'function') {
          window.affirm.ui.ready(function () {
            if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === 'function') {
              window.affirm.ui.refresh();
            }
          });
        }
      } catch (e) {}
    }
  }

  function updateAfterpayMessages(section, variant) {
    if (!variant || typeof variant.price !== 'number') return;

    toArray(section.querySelectorAll('[data-afterpay-placement]')).forEach(function (el) {
      el.setAttribute('data-amount', (variant.price / 100).toFixed(2));
    });

    if (window.AfterPay && typeof window.AfterPay.refresh === 'function') {
      try {
        window.AfterPay.refresh();
      } catch (e) {}
    }
  }

  function refreshInstallmentProviders(section, variant) {
    if (!section || !variant) return;

    updateInstallmentForms(section, variant);
    updatePayPalMessages(section, variant);
    updateKlarnaMessages(section, variant);
    updateAffirmMessages(section, variant);
    updateAfterpayMessages(section, variant);

    window.clearTimeout(section.__mpgInstallmentRefreshTimer1);
    window.clearTimeout(section.__mpgInstallmentRefreshTimer2);
    section.__mpgInstallmentRefreshTimer1 = window.setTimeout(function () {
      updateKlarnaMessages(section, variant);
      updateAffirmMessages(section, variant);
      updateAfterpayMessages(section, variant);
    }, 400);
    section.__mpgInstallmentRefreshTimer2 = window.setTimeout(function () {
      updateKlarnaMessages(section, variant);
      updateAffirmMessages(section, variant);
      updateAfterpayMessages(section, variant);
    }, 1200);
  }

  function updatePayPalMessages(section, variant) {
    if (!variant || typeof variant.price !== 'number') return;

    var amountInDollars = (variant.price / 100).toFixed(2);
    var messages = toArray(section.querySelectorAll('[data-pp-message]'));
    if (!messages.length) return;

    messages.forEach(function (el) {
      el.setAttribute('data-pp-amount', amountInDollars);
    });

    if (window.ProductInstallmentList && typeof window.ProductInstallmentList.refreshPayPalMessages === 'function') {
      window.ProductInstallmentList.refreshPayPalMessages(section);
      return;
    }

    var paypalApi =
      typeof window.PayPalSDK !== 'undefined' && window.PayPalSDK.Messages
        ? window.PayPalSDK
        : typeof window.paypal !== 'undefined' && window.paypal.Messages
          ? window.paypal
          : null;

    if (paypalApi) {
      messages.forEach(function (el) {
        if (el.dataset.ppRenderedAmount !== amountInDollars && el.childElementCount > 0) {
          el.innerHTML = '';
        }
        try {
          paypalApi.Messages({ amount: amountInDollars }).render(el);
          el.dataset.ppRenderedAmount = amountInDollars;
          el.classList.add('is-ready');
        } catch (e) {}
      });
    }
  }

  function updateVariantMedia(section, variant) {
    if (!variant || !variant.featured_media) return;

    var mediaId = variant.featured_media.id;
    if (!mediaId) return;

    var sectionId = section.getAttribute('data-section-id') || '';
    var thumbSelector = '[data-media-id="' + sectionId + '-' + mediaId + '"]';
    var thumb = section.querySelector(thumbSelector);

    if (!thumb) return;

    var targetIndex = thumb.getAttribute('data-mpg-general-target-index');
    var kind = thumb.getAttribute('data-mpg-general-kind');

    if (targetIndex == null || kind !== 'image') return;

    var index = parseInt(targetIndex, 10);
    if (!Number.isFinite(index)) return;

    var currentMode = getMediaMode(section);
    if (currentMode !== 'image') {
      setMediaMode(section, 'image', index, true);
    } else {
      var swiper = getMediaSwiper(section, 'image');
      if (swiper && swiper.activeIndex !== index) {
        swiper.slideTo(index);
      }
    }
  }

  function updatePriceUi(section, variant) {
    var wrap = section.querySelector('[data-mpg-price]');
    if (!wrap) return;

    var currentEl = wrap.querySelector('[data-mpg-price-current]');
    var compareEl = wrap.querySelector('[data-mpg-price-compare]');
    var discountEl = wrap.querySelector('[data-mpg-price-discount]');
    if (!currentEl || !compareEl || !discountEl) return;

    var price = variant && typeof variant.price === 'number' ? variant.price : null;
    var compareAt = variant && typeof variant.compare_at_price === 'number' ? variant.compare_at_price : null;
    if (price == null) return;

    currentEl.textContent = formatMoney(price);

    var hasDiscount = compareAt != null && compareAt > price;
    setHidden(compareEl, !hasDiscount);
    setHidden(discountEl, !hasDiscount);

    if (hasDiscount) {
      compareEl.textContent = formatMoney(compareAt);
      discountEl.textContent = '-' + formatMoney(compareAt - price);
    }
  }

  function updatePurchaseTotals(section, variant) {
    var totals = section.querySelector('[data-mpg-purchase-totals]');
    if (!totals) return;

    var currentEl = totals.querySelector('[data-mpg-purchase-current]');
    var compareEl = totals.querySelector('[data-mpg-purchase-compare]');
    var discountEl = totals.querySelector('[data-mpg-purchase-discount]');
    if (!currentEl || !compareEl || !discountEl) return;

    var form = section.querySelector('form[data-type="add-to-cart-form"]');
    var qtyInput = form && form.querySelector('input[name="quantity"]');
    var qty = Number(qtyInput && qtyInput.value);
    if (!Number.isFinite(qty) || qty < 1) qty = 1;

    var price = variant && typeof variant.price === 'number' ? variant.price : null;
    var compareAt = variant && typeof variant.compare_at_price === 'number' ? variant.compare_at_price : null;
    if (price == null) return;

    var linePrice = price * qty;
    currentEl.textContent = formatMoney(linePrice);

    var hasDiscount = compareAt != null && compareAt > price;
    setHidden(compareEl, !hasDiscount);
    setHidden(discountEl, !hasDiscount);

    if (hasDiscount) {
      var lineCompare = compareAt * qty;
      compareEl.textContent = formatMoney(lineCompare);
      discountEl.textContent = '-' + formatMoney(lineCompare - linePrice);
    }
  }

  function getMatchedVariant(section, variants) {
    var radiosRoot = section.querySelector('variant-radios.mpgGeneral__variantRadios');
    if (radiosRoot && variants && variants.length) {
      var optionValues = toArray(radiosRoot.querySelectorAll('.mpgGeneral__optionField')).map(function (fieldset) {
        var checked = fieldset.querySelector('.mpgGeneral__optionInput:checked');
        return checked ? checked.value : null;
      });

      if (optionValues.length) {
        var matched = variants.find(function (variant) {
          return [variant.option1 || null, variant.option2 || null, variant.option3 || null].every(function (value, index) {
            return optionValues[index] == null || optionValues[index] === value;
          });
        });
        if (matched) return matched;
      }
    }

    return null;
  }

  function getSelectedVariant(section, variants) {
    var matchedVariant = getMatchedVariant(section, variants);
    if (matchedVariant) return matchedVariant;

    var id = getSelectedVariantId(section);
    if (!id) return null;
    return variants.find(function (v) {
      return Number(v.id) === Number(id);
    }) || null;
  }

  function getSelectedVariantId(section) {
    var forms = toArray(section.querySelectorAll('form[data-type="add-to-cart-form"]'));

    for (var i = 0; i < forms.length; i += 1) {
      var idInput = forms[i].querySelector('input[name="id"]');
      var id = idInput && idInput.value;
      var asNumber = Number(id);
      if (Number.isFinite(asNumber)) return asNumber;
    }

    return null;
  }

  function initPrice(section) {
    if (!section || section.__mpgGeneralPriceBound) return;
    section.__mpgGeneralPriceBound = true;

    var variants = readVariantsFromDom() || [];
    if (!variants.length) return;

    function syncVariantIdInput(section, variant) {
      if (!section || !variant) return;

      var nextId = String(variant.id);
      toArray(section.querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"]')).forEach(function (input) {
        if (input.value !== nextId) {
          input.value = nextId;
        }
      });
    }

    function refresh(options) {
      options = options || {};
      updateOptionLabels(section);
      syncOptionValueStates(section, variants);
      var variant = getSelectedVariant(section, variants);
      if (!variant) {
        // Liquid 已按 current_variant 渲染按钮；解析失败时不强行改成售罄
        return;
      }
      syncVariantIdInput(section, variant);
      // 旧模板 onVariantInit 里注释掉了 updateURL，只在用户切换变体时追加 ?variant=
      if (options.updateUrl) {
        updateVariantUrl(section, variant);
      }
      updateMainPurchaseButton(section, variant);
      var quantity = syncQuantityForVariant(section, variant);
      updateNotifyState(section, variant);
      updateStickyVariantSelect(section, variant);
      updatePriceUi(section, variant);
      updatePurchaseTotals(section, variant);
      refreshInstallmentProviders(section, variant);
      updateStickyPrice(section, variant, quantity != null ? quantity : (section.querySelector('form[data-type="add-to-cart-form"] input[name="quantity"]') || {}).value);
      updateStickyEtaVisibility(section, variant);
      updateStickyButtons(section, variant);
      updateVariantMedia(section, variant);
    }

    refresh();

    section.addEventListener('change', function (event) {
      var target = event.target;
      if (!target) return;

      if (target.closest('variant-radios.mpgGeneral__variantRadios') && target.classList.contains('mpgGeneral__optionInput')) {
        window.requestAnimationFrame(function () {
          refresh({ updateUrl: true });
        });
        return;
      }

      if (
        target.name === 'quantity' ||
        target.name === 'id' ||
        target.closest('variant-radios') ||
        target.closest('variant-selects')
      ) {
        var shouldUpdateUrl =
          target.name === 'id' ||
          !!target.closest('variant-radios') ||
          !!target.closest('variant-selects');
        window.requestAnimationFrame(function () {
          refresh({ updateUrl: shouldUpdateUrl });
        });
      }
    });

    section.addEventListener('input', function (event) {
      var target = event.target;
      if (!target) return;
      if (target.name === 'quantity') {
        window.requestAnimationFrame(refresh);
      }
    });
  }
})();
